import React, { useState, useEffect } from 'react';
import { Grid, Typography, MenuItem, TextField } from '@mui/material';
import WebHookField from './WebHookField';

const WebhooksOptions = ({ formData, handleNestedChange, tempTheme }) => {
  const [newVals, setNewVals] = useState(formData.webhooks);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleDebouncedChange = debounce((name, value) => {
    setNewVals((prevVals) => ({
      ...prevVals,
      [name]: value,
    }));
  }, 3000);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    handleNestedChange('webhooks', name, value);
    handleDebouncedChange(name, value);
  };

  // useEffect(() => {
  //   console.log('New Values:', newVals);
  // }, [newVals]);

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Webhooks Options
      </Typography>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <WebHookField
            webhookUrl={formData.webhooks.ssoUrl}
            setWebhookUrl={(value) => handleInputChange({ target: { name: 'ssoUrl', value } })}
            tempTheme={tempTheme}
            label="SSO URL"
            name="ssoUrl"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <WebHookField
            webhookUrl={formData.webhooks.userSignupWebhookUrl}
            setWebhookUrl={(value) => handleInputChange({ target: { name: 'userSignupWebhookUrl', value } })}
            tempTheme={tempTheme}
            label="User Signup Webhook URL"
            name="userSignupWebhookUrl"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <WebHookField
            webhookUrl={formData.webhooks.firehoseWebhookUrl}
            setWebhookUrl={(value) => handleInputChange({ target: { name: 'firehoseWebhookUrl', value } })}
            tempTheme={tempTheme}
            label="Firehose Webhook URL"
            name="firehoseWebhookUrl"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <WebHookField
            webhookUrl={formData.webhooks.webhookApiKey}
            setWebhookUrl={(value) => handleInputChange({ target: { name: 'webhookApiKey', value } })}
            tempTheme={tempTheme}
            label="Webhook API Key"
            name="webhookApiKey"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <WebHookField
            webhookUrl={formData.webhooks.patientNoteWebhookUrl}
            setWebhookUrl={(value) => handleInputChange({ target: { name: 'patientNoteWebhookUrl', value } })}
            tempTheme={tempTheme}
            label="Patient Note Webhook URL"
            name="patientNoteWebhookUrl"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <WebHookField
            webhookUrl={formData.webhooks.workflowWebhookUrl}
            setWebhookUrl={(value) => handleInputChange({ target: { name: 'workflowWebhookUrl', value } })}
            tempTheme={tempTheme}
            label="Workflow Webhook URL"
            name="workflowWebhookUrl"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="Workflow Webhook Version"
            name="workflowWebhookVersion"
            value={formData.webhooks.workflowWebhookVersion}
            onChange={handleInputChange}
            select
            sx={tempTheme}
          >
            <MenuItem value="All">All (default)</MenuItem>
            {/* Add more versions if necessary */}
          </TextField>
        </Grid>
      </Grid>
    </>
  );
};

export default WebhooksOptions;
